import { chakra } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ButtonCard, ButtonCardProps } from './ButtonCard';

export interface LinkCardProps extends Omit<ButtonCardProps, 'onClick'> {
  to: string;
}

// chakra-styled <a> so the wrapper picks up the design-system focus halo
// and never renders a default browser underline. ButtonCard supplies its
// own border + hover bg, so we only need this anchor to be a clean,
// focusable, non-underlined block.
const StyledLink = chakra(ReactRouterLink, {
  base: {
    display: 'block',
    borderRadius: 'sm',
    textDecoration: 'none',
    _hover: { textDecoration: 'none' },
    _focus: { textDecoration: 'none' },
    _focusVisible: {
      boxShadow: 'focus',
      outline: 'none',
    },
  },
});

export const LinkCard = ({ to, ...rest }: LinkCardProps) => {
  return (
    <StyledLink to={to}>
      <ButtonCard {...rest} />
    </StyledLink>
  );
};
